const Style = {
  // ── Page header ───────────────────────────────────────────────────────────────
  pageTitle: 'text-2xl font-bold text-gray-900 m-0',
  pageSubtitle: 'text-gray-500 text-sm mt-1 mb-5',
  topBar: 'flex justify-between items-center mb-4',

  // ── Search ────────────────────────────────────────────────────────────────────
  searchWrap: 'relative w-[480px]',
  searchIcon: 'absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex',
  searchInput:
    'w-full pl-[38px] pr-3 h-[37px] border border-gray-200 rounded-lg text-sm text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // ── Filters button ────────────────────────────────────────────────────────────
  filterBtnWrap: 'relative',
  filterBtnBase: 'flex items-center gap-1.5 py-2 px-4 border rounded-lg text-sm cursor-pointer transition-colors',
  filterBtnActive: 'border-blue-600 bg-blue-50 text-blue-600',
  filterBtnInactive: 'border-gray-200 bg-white text-gray-700',

  // ── Filter panel ──────────────────────────────────────────────────────────────
  filterPanel:
    'absolute top-[calc(100%+8px)] right-0 z-[200] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] w-[300px] p-5',
  filterSection: 'mb-5',
  filterSectionLbl: 'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] mb-2',

  // Reward status pill buttons
  statusChips: 'flex gap-1.5 flex-wrap',
  statusBtnBase: 'py-1 px-3.5 rounded-full text-[13px] font-medium cursor-pointer border transition-colors',
  statusBtnActive: 'border-blue-600 bg-blue-50 text-blue-600',
  statusBtnInactive: 'border-gray-200 bg-gray-100 text-gray-700',

  // Date range
  dateCol: 'flex flex-col gap-2',
  dateRow: 'flex items-center gap-2',
  dateFromToLabel: 'text-xs text-gray-400 w-7 shrink-0',
  dateInput:
    'w-full h-8 px-2.5 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // Panel footer
  filterFooter: 'flex items-center justify-between',
  filterClearBtn: 'bg-transparent border-none p-0 text-[13px] text-gray-500 cursor-pointer underline',
  filterApplyBtn:
    'bg-blue-600 text-white border-none rounded-lg py-2 px-5 text-sm font-medium cursor-pointer hover:bg-blue-700',

  // ── Table cells (renderCell) ──────────────────────────────────────────────────
  cellPerson: 'px-4 h-[60px] whitespace-nowrap',
  cellPersonName: 'font-medium text-gray-900',
  cellPersonLink: 'text-inherit no-underline hover:underline',
  cellPersonEmail: 'text-gray-400 text-xs',
  cellPersonUnknown: 'text-gray-400 italic',
  cellAccount: 'px-4 h-[60px] text-gray-700',
  cellAccountLink: 'text-blue-600 no-underline font-medium',
  cellStatus: 'px-4 h-[60px]',
  cellDate: 'px-4 h-[60px] whitespace-nowrap',
  cellDateMain: 'text-gray-900',
  cellDateTime: 'text-gray-400 text-xs',
  cellReward: 'px-4 h-[60px] whitespace-nowrap',

  // Pills (referee subscription status + reward)
  pillBase: 'inline-block py-0.5 px-2.5 rounded-full text-xs font-medium capitalize',
  pillGood: 'bg-green-50 text-green-700',
  pillWarn: 'bg-amber-50 text-amber-700',
  pillBad: 'bg-red-50 text-red-700',
  pillNeutral: 'bg-gray-100 text-gray-600',
};

export default Style;
